module.exports = __webpack_public_path__ + "img/131f8f7.svg";